import type { IxcGenerateV1MonthlyStatementsJobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const DOCGEN_MONTHLY_STATEMENT_JOB_BASE_PATH = getResolvedPath('/clearing/operations/generate/monthly-statement/job');

export const getDocgenMonthlyStatementJobPath: EntityPathBuilder<IxcGenerateV1MonthlyStatementsJobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return DOCGEN_MONTHLY_STATEMENT_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.jobId) {
        return undefined;
      }

      return getResolvedPath(`${DOCGEN_MONTHLY_STATEMENT_JOB_BASE_PATH}/$jobId`, context.keys);
    }
  }
};

export function getDocgenMonthlyStatementJobDetailPath(jobId: string | undefined) {
  if (!jobId) {
    return undefined;
  }

  return getDocgenMonthlyStatementJobPath({ kind: 'detail', keys: { jobId } });
}
